import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './CreateRole.css';
import { createRole, getRoleById, updateRole } from '../../../services/roleServiceMapService';

const CreateRole = () => {
  const { roleId } = useParams();  // get roleId from URL (undefined if creating)
  const navigate = useNavigate();
  const [customAlert, setCustomAlert] = useState({ show: false, message: '', onClose: null });
  const showAlert = (message, onClose = null) => {
    setCustomAlert({ show: true, message, onClose });
  };

  const closeAlert = () => {
    setCustomAlert({ show: false, message: '', onClose: null });
    if (customAlert.onClose) {
      customAlert.onClose(); // call post-close callback
    }
  };
  const [roleName, setRole] = useState('');
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});


  // Fetch role data if roleId exists (edit mode)
  useEffect(() => {
    if (!roleId) return; // create mode — no fetch

    const fetchRole = async () => {
      try {
        const roleData = await getRoleById(roleId);
        setRole(roleData.roleName || '');
      } catch (error) {
        console.error('Failed to fetch role data:', error);
        alert('Failed to load role data');
      }
    };

    fetchRole();
  }, [roleId]);

  // Handle English input change
  const handleRole = (e) => {
    const value = e.target.value;
    setRole(value);

    // Clear error for 'role' as user starts typing
    if (errors.roleName) {
      setErrors(prevErrors => ({ ...prevErrors, roleName: '' }));
    }
  };


  // Handle form submit for create or update
  const handleSubmit = async () => {
    const newErrors = {};
    if (!roleName.trim()) {
      if (!roleName.trim()) newErrors.roleName = "Please enter the role";

    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    const token = localStorage.getItem('access_token');

    try {
      if (roleId) {
        // Update existing role -> Update Payload structure
        const updatePayload = {
          roleName: roleName.trim(),
        };

        // await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/role/${roleId}`, updatePayload, );
        await updateRole(roleId,updatePayload);
        showAlert('Role updated successfully.', () => navigate('/addRole'));
      } else {
        // Create new role -> Create Payload structure
        const createPayload = {
          roleName: roleName.trim(),
        };

        //  await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/role`,createPayload,);
        await createRole(createPayload)
        showAlert('Role created successfully.', () => navigate('/addRole'));
      }
    } catch (error) {
      console.error('Error saving role:', error);
      showAlert('This role already exists. Please enter a different role.');
    } finally {
      setLoading(false);
    }
  };


  // Clear form inputs
  const handleClear = () => {
    navigate("/addRole")
  };

  return (
    <div className="create-role-container">
      <div className='role-roleName-header'>
        <h2>{roleId ? 'Update Role' : 'Add Role'}</h2>


      </div>
      <div className="input-group-role">
        <div className={`input-field ${roleName ? 'filled' : ''}`}>
          <input
            type="text"
            value={roleName}
            onChange={handleRole}
          //required
          />
          <label> <span className="star">*</span>Role</label>
          {errors.role && (
            <div className="error-message-display">
              {errors.role}
            </div>
          )}
        </div>


      </div>

      <div className="button-group-role">
        <button onClick={handleSubmit} disabled={loading} className="subt-btn-role">
          {loading ? 'Saving...' : (roleId ? 'Update' : 'Submit')}
        </button>
        <button onClick={handleClear} className="clear-btn-role">Cancel</button>
      </div>
      {customAlert.show && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p>{customAlert.message}</p>
            <div className="confirm-actions">
              <button type="button" onClick={closeAlert}>OK</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CreateRole;
